import { IUser } from '@core/user';
import { WizardBasket } from '@wizard/models';

export type WizardBasketBroadcastEventType =
  'Clear'
  | 'Delete'
  | 'Get'
  | 'Post'
  | 'Update'
  ;

export interface WizardBasketBroadcastEventListener extends MessageEvent<WizardBasketBroadcastEvent> { }

export interface WizardBasketBroadcastEvent {
  id: string;
  key: string;
  action: WizardBasketBroadcastEventType;
  user: IUser;
  data: WizardBasket;
  // 🧰 optional, keep for "sync" this if needed
  timeStamp?: number;
}

export type WizardBasketBroadcastEventKeys = { [key in WizardBasketBroadcastEventType]: WizardBasketBroadcastEventType };

export const WizardBasketBroadcastEventEnum: WizardBasketBroadcastEventKeys = {
  Clear: 'Clear',
  Delete: 'Delete',
  Get: 'Get',
  Post: 'Post',
  Update: 'Update',
};
